import { useEffect, useState } from "react";
import { Association } from "src/interfaces/Common";
import { PagesID } from "@utils/utilsConfigurations";
import { ServicesURL } from "@utils/utilsApi";

export const useAddEditContract = (dataDetail?: any) => {
  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [supplierAssociation, setSupplierAssociation] = useState<any>([]);
  const [accountsAssociation, setAccountsAssociation] = useState<any>([]);

  const formatSupplier = (supplier: any) => {
    supplier.label = `${supplier.business_name} - ${supplier.sap_code}`;
    setSupplierAssociation([supplier]);
  };

  const formatAccount = (account: any) => {
    account.label = `${account.sap_number} - ${account.name}`;
    setAccountsAssociation([account]);
  };

  useEffect(() => {
    if (dataDetail?.supplier) {
      formatSupplier(dataDetail.supplier);
    }
    if (dataDetail?.account) {
      formatAccount(dataDetail.account);
    }
  }, [dataDetail]);

  const resetContractAssociations = () => {
    if (dataDetail?.supplier) {
      formatSupplier(dataDetail.supplier);
    } else {
      setSupplierAssociation([]);
    }

    if (dataDetail?.account) {
      formatAccount(dataDetail.account);
    } else {
      setAccountsAssociation([]);
    }
  };

  const setOpenAssociation = (accessorKey: string, value: boolean) => {
    switch (accessorKey) {
      case "supplier":
        setOpenAssociations(
          value
            ? {
                accessorKey: "supplier",
                mediaType: "supplier",
                type: "table",
                titleKey: "supplier-association",
                pageId: PagesID["suppliers"],
                service: ServicesURL.getSuppliers,
                multiChoice: false,
              }
            : value,
        );
        break;
      case "account":
        setOpenAssociations(
          value
            ? {
                accessorKey: "account",
                mediaType: "account",
                type: "table",
                titleKey: "account-association",
                pageId: PagesID["accounts"],
                service: `${ServicesURL.getBankAccounts}`,
                multiChoice: false,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "supplier":
        return supplierAssociation;
      case "account":
        return accountsAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "supplier":
        setSupplierAssociation(
          supplierAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
      case "account":
        setAccountsAssociation(
          accountsAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "supplier":
        const objToSupplierAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
                key: key.split("||")[2],
              };
            } else {
              return supplierAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setSupplierAssociation(objToSupplierAssociation);
        break;
      case "account":
        const objToAccountsAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return accountsAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setAccountsAssociation(objToAccountsAssociation);
        break;
    }
  };

  return {
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetContractAssociations,
    setSupplierAssociation,
    setAccountsAssociation,
    accountsAssociation,
    supplierAssociation,
    openAssociations,
  };
};
